import hallOne from "../images/hall1.jpg"
import hallTwo from "../images/hall2.jpg"
import hallThree from "../images/hall3.jpg"

export const halls = [
  { id: 1, name: "Малый зал", image: hallOne },
  { id: 2, name: "Мастерская", image: hallTwo },
  { id: 3, name: "Детский зал", image: hallThree },
  { id: 4, name: "Лофт", image: hallOne },
  { id: 5, name: "Хромакей", image: hallTwo },
  { id: 6, name: "Малый зал", image: hallThree },
  { id: 7, name: "Мастерская", image: hallOne },
  { id: 8, name: "Детский зал", image: hallTwo },
  { id: 9, name: "Лофт", image: hallThree },
  { id: 10, name: "Хромакей", image: hallOne },
];